"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTupleDoesNotExistError = exports.isTupleAlreadyExistsError = void 0;
const sdk_1 = require("@openfga/sdk");
const isTupleAlreadyExistsError = (e) => {
    return (e instanceof sdk_1.FgaApiError &&
        e.responseData.code === "write_failed_due_to_invalid_input" &&
        e.responseData.message.includes("already exists"));
};
exports.isTupleAlreadyExistsError = isTupleAlreadyExistsError;
const isTupleDoesNotExistError = (e) => {
    return (e instanceof sdk_1.FgaApiError &&
        e.responseData.code === "write_failed_due_to_invalid_input" &&
        e.responseData.message.includes("does not exist"));
};
exports.isTupleDoesNotExistError = isTupleDoesNotExistError;
//# sourceMappingURL=errors.js.map